import React from 'react';

import { StringKeyValue } from '../../actions/types';
import CustomAppTypes from '../../config/customAppTypes';
import { ContextReducer } from '../../reducers/context';
import { LbsReducer } from '../../reducers/lbs';
import { UserReducer } from '../../reducers/user';
import { getAbortUrlKey } from '../../util/navUtil';

export interface BankIDSignProps {
    url: string;
    context: ContextReducer;
    lbs: LbsReducer;
    user: UserReducer;
    text: StringKeyValue;
}

const BankIDSign = (props: BankIDSignProps) => {
    const iframeStyle = {
        width: '100%',
        height: '438px',
        margin: 0,
        border: '0 none',
        outline: '0 none',
    };
    const { url, context, lbs, user, text } = props;
    const lbsbnr = CustomAppTypes.isLbs(context) ? `?lbsbnr=${lbs.lbsBankregnr}` : '';
    const exitUrl = `${window.location.href}${lbsbnr}`;
    const cancelUrl = `${window.location.origin}${text[getAbortUrlKey(user, context)]}`;

    return (
        <iframe
            title="esignering-iframe"
            style={iframeStyle}
            src={`${url}&deflecttarget=_top&exit=${exitUrl}&cancel=${cancelUrl}`}
        />
    );
};

export default BankIDSign;
